import React from "react";
import levinBeautyrestLogo from "../images/levinBeautyrest.webp";
function Header() {
  return (
    <div className="row">
      <div className="col-md-12">
        <div className="logo">
          {/* <img
            src={levinBeautyrestLogo}
            alt="levinBeautyrest-logo.png"
            className="img-responsive"
          /> */}
          <svg
            width={60}
            height={25}
            viewBox="0 0 60 25"
            fill="#002e66"
            xmlns="http://www.w3.org/2000/svg"
            className="img-responsive"
          >
            <path d="M7.41104 6.05078V11.1257H1.53674V6.05078H0V18.2208H1.53674V12.6039H7.41104V18.2208H8.94777V6.05078H7.41104Z" />
            <path d="M14.9453 6.05078V18.2208H23.1371V16.8042H16.4944V12.6039H22.3192V11.1627H16.4944V7.45501H23.1371V6.05078H14.9453Z" />
            <path d="M29.1406 6.05078V18.2208H36.5641V16.7919H30.6774V6.05078H29.1406Z" />
            <path d="M44.1364 6.05078H42.5625V18.2208H44.1364V6.05078Z" />
            <path d="M58.0226 6.05078L54.9987 10.9779L51.9252 6.05078H50.215L54.0073 12.0742L50.1406 18.2208H51.8261L54.8995 13.2197L57.9978 18.2208H59.708L55.8414 12.0742L59.6585 6.05078H58.0226Z" />
          </svg>
        </div>
      </div>
    </div>
  );
}
export default Header;
